<template>
    <v-form ref="form">
        <v-card>
            <v-card-title>
                <span class="headline">{{ $vuetify.lang.t('$vuetify.custom.market.followTitle') }}</span>
            </v-card-title>
            <v-card-text>
                <v-row class="mt-6">
                    <v-col cols="12">
                        <v-select
                            :items="followTypeItems"
                            :label="$vuetify.lang.t('$vuetify.custom.market.followWay')"
                            hide-details
                            solo
                            v-model="formData.type"
                        ></v-select>
                    </v-col>
                    <v-col cols="12">
                        <v-text-field
                            :label="$vuetify.lang.t('$vuetify.custom.market.followTitle')"
                            v-model="formData.content"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                        <v-menu
                            ref="menu"
                            v-model="menu"
                            :close-on-content-click="false"
                            :return-value.sync="formData.nextTime"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                        >
                            <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    v-model="formData.nextTime"
                                    label="下次跟进时间"
                                    readonly
                                    v-bind="attrs"
                                    v-on="on"
                                ></v-text-field>
                            </template>
                            <v-date-picker v-model="formData.nextTime" locale="zh-cn" no-title scrollable>
                                <v-spacer></v-spacer>
                                <v-btn text color="primary" @click="menu = false">取消</v-btn>
                                <v-btn text color="primary" @click="$refs.menu.save(formData.nextTime)">确定</v-btn>
                            </v-date-picker>
                        </v-menu>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-row>
                    <v-col cols="6">
                        <v-btn color="error" dark @click="hiddenDialog">{{
                                $vuetify.lang.t('$vuetify.custom.cancelBtn')
                            }}
                        </v-btn>
                    </v-col>
                    <v-col cols="6">
                        <v-btn color="success" dark @click="addFollow">{{ $vuetify.lang.t('$vuetify.custom.okBtn') }}</v-btn>
                    </v-col>
                </v-row>
            </v-card-actions>
        </v-card>
    </v-form>
</template>
<style></style>
<script>
export default {
    name: 'mark-follow',
    model: {
        prop: 'followDialog',
        event: 'parent-event'
    },
    props: {
        followId: String,
        followDialog: Boolean
    },
    mounted() {
        this.formData.clewId = this.followId
    },
    data: () => ({
        menu: false,
        followTypeItems:[
            {text: '电话', value: '1'},
            {text: '微信', value: '2'},
            {text: 'qq', value: '3'},
            {text: '面访', value: '4'},
        ],
        formData: {
            clewId:'',
            type: '',
            content: '',
            nextTime: new Date().toISOString().substr(0, 10),
        },
        rules: {
            required: value => !!value || '请输入'
        },

    }),
    watch: {
        followDialog() {
            if (this.followDialog) {
                this.formData.nextTime = new Date().toISOString().substr(0, 10)
                this.formData.clewId = this.followId
            }
        }
    },
    methods: {
        addFollow(){
            if (this.$refs.form.validate()) {
                this.$api.follow.addFollowRecord(this.formData).then(data => {
                    if (data.flag) {
                        this.$dialog.alert(this.$vuetify.lang.t('$vuetify.custom.addSuccess'));
                        this.$emit('queryFollow')
                        this.hiddenDialog();
                    } else {
                        this.$dialog.alert(data.msg)
                    }
                })
            }
        },
        hiddenDialog() {
            this.$refs.form.reset()
            this.$emit('parent-event', false);
        },
    },
}
</script>
